<template>
  <div class="gwc-box">
	<div class="gwc-box-container" v-if="!isDetail">
		<div class="gwc-box-top">
		  <span>{{$t('all.quanbushangpin')}}</span>
		  <img src="../../assets/image/tanchuang_x@2x.png" alt="关闭" @click="handleClose" />
		</div>
		<div class="gwc-box-list">
			<div :class="index == listIndex?'gwc-box-list-item':'gwc-box-list-item1'" v-for="(item,index) in list" :key="index">
				<div class="gwc-box-list-item-img">
					<img class="gwc-box-list-item-img-img" :src="item.masterImg[0]" alt="" @error="handleImgError"/>
					<!-- <div class="paixu">1</div>
					<div class="jiangjiezhong">
						<img src="../../assets/image/renshu@2x.png" alt=""/>
						<span>讲解中</span>
					</div> -->
					<div class="yiqiangguang" v-if="item.inventory == 0">- {{$t('all.yiqiangguang')}} -</div>
				</div>
				<div class="gwc-box-list-item-content">
					<div class="gwc-box-list-item-content-name">{{item.goodsName}}</div>
					<div class="gwc-box-list-item-content-kucun">剩余库存：{{item.inventory}}</div>
					<div class="gwc-box-list-item-content-price">
						<div class="gwc-box-list-item-content-price-left">
							<span class="gwc-box-list-item-content-price-left-span">USDN</span>
							<span class="gwc-box-list-item-content-price-left-span1">{{item.price}}</span>
						</div>
						<div class="gwc-box-list-item-content-price-btn" @click="handleDetail(index)">{{$t('all.jiagou')}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="gwc-box-container" v-if="isDetail">
		<div class="gwc-box-top">
		  <span>{{$t('all.shangpinxiangqing')}}</span>
		  <img src="../../assets/image/tanchuang_x@2x.png" alt="关闭" @click="handleClose"/>
		</div>
		<div class="gwc-box-xq">
			<div class="gwc-box-xq-lbt">
				<carousel :images="data.masterImg" :interval="3000"/>
			</div>
			<div class="gwc-box-xq-name">{{data.goodsName}}</div>
			<div class="gwc-box-xq-price">
				<div class="gwc-box-xq-price-left">
					<span class="gwc-box-xq-price-span">USDN</span>
					<span class="gwc-box-xq-price-span-span1">{{data.price}}</span>
				</div>
				<div class="gwc-box-xq-price-right">剩余库存：{{data.inventory}}</div>
			</div>
			<div class="gwc-box-xq-title">
				<span class="gwc-box-xq-title-span"></span>
				<span class="gwc-box-xq-title-span1">{{$t('all.shangpinxiangqing')}}</span>
				<span class="gwc-box-xq-title-span"></span>
			</div>
			<div class="gwc-box-xq-img">
				<img v-for="(item,index) in data.masterImg" :key="index" :src="item" alt="" />
			</div>
		</div>
		<div class="gwc-box-xq-btn">
			<div class="gwc-box-xq-btn-btn" @click="show = true">{{$t('all.lijijiagou')}}</div>
		</div>
		
		<div class="gwc-mask" v-if="show" @click="show = false"></div>
		<div class="gwc-mask-model" v-if="show">
			<div class="gwc-mask-model-top">
				<img src="../../assets/image/tanchuang_x@2x.png" alt="关闭" @click="show = false"/>
			</div>
			<div class="gwc-mask-model-goods">
				<img class="gwc-mask-model-goods-img" :src="data.masterImg[0]" alt="" @error="handleImgError"/>
				<div class="gwc-mask-model-goods-content">
					<div class="gwc-mask-model-goods-content-price">
						<span class="gwc-mask-model-goods-content-price-span">USDN</span>
						<span class="gwc-mask-model-goods-content-price-span1">{{data.specificationList[ggIndex].price*num}}</span>
					</div>
					<div class="gwc-mask-model-goods-content-kucun">剩余库存：{{data.inventory}}</div>
					<div class="gwc-mask-model-goods-content-num">
						<div class="gwc-mask-model-goods-content-num-left">{{$t('all.yixuan')}}：{{data.specificationList[ggIndex].name}}</div>
						<div class="gwc-mask-model-goods-content-num-right">
							<img src="../../assets/image/shuliang_-@2x.png" alt="" @click="handleNum(-1)"/>
							<span>{{num}}</span>
							<img src="../../assets/image/shuliang_+@2x.png" alt="" @click="handleNum(1)"/>
						</div>
					</div>
				</div>
			</div>
			<div class="gwc-mask-model-gg">
				<div class="gwc-mask-model-gg-title">{{$t('all.xuanzeguige')}}</div>
				<div class="gwc-mask-model-gg-list">
					<div :class="ggIndex === index?'gwc-mask-model-gg-list-item':'gwc-mask-model-gg-list-item1'" v-for="(item,index) in data.specificationList" :key="index" @click="handleGg(index)">
						<div class="gwc-mask-model-gg-list-item-left">
							<img :src="data.masterImg[0]" alt="" @error="handleImgError"/>
							<span :class="ggIndex===index?'gwc-mask-model-gg-list-item-left-span':'gwc-mask-model-gg-list-item-left-span1'">{{item.name}}</span>
							<span :class="ggIndex===index?'gwc-mask-model-gg-list-item-left-span2':'gwc-mask-model-gg-list-item-left-span3'">库存：{{item.inventory}}</span>
						</div>
						<div class="gwc-mask-model-gg-list-item-right">
							<span :class="index === ggIndex?'gwc-mask-model-gg-list-item-right-span':'gwc-mask-model-gg-list-item-right-span_1'">USDN</span>
							<span :class="index === ggIndex?'gwc-mask-model-gg-list-item-right-span1':'gwc-mask-model-gg-list-item-right-span1_1'">{{item.price}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="gwc-box-xq-btn">
				<div class="gwc-box-xq-btn-btn" @click="submitOrder">{{$t('all.lijijiagou')}}</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import carousel from "../carousel/carousel.vue";
import { getGoodsList,submitOrder } from "@/api/zhibo";
export default {
  components: {
    carousel
  },
  data() {
    return {
	  list:[],
	  listIndex:0,
	  originList:[],
	  carouselImages:['https://belatedly.oss-cn-beijing.aliyuncs.com/image/belatedly/iOS/925421766804676585','https://belatedly.oss-cn-beijing.aliyuncs.com/image/belatedly/iOS/925421766804676585'],
	  show:false,
	  num:1,
	  ggIndex:0,
	  isDetail:false,
	  data:'',
	  defaultGoodsImg: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1768282483370_nzuet3anc9h.png'
    };
  },
  mounted() {
	this.getGoodsList()
  },
  methods: {
	//直播间商品
	async getGoodsList(){
		const res = await getGoodsList({ liveId: this.$route.query.liveId });
		this.list = res.data
		this.list.forEach(v=>{
		    v.masterImg = []
		    v.inventory = 0
		    v.price = 0
		    v.mediasList.forEach(i=>{
		        v.masterImg.push(i.uri)
		    })
		    v.specificationList.forEach(i=>{
		        v.inventory += i.inventory
		    })
		    const priceArr = v.specificationList.map(item => item.price);
		    if (v.specificationList.length === 1) {
		        v.price = priceArr[0];
		    } else {
		        const minPrice = Math.min(...priceArr);
		        const maxPrice = Math.max(...priceArr);
		        // 新增判断：最小价格与最大价格是否相等
		        if (minPrice === maxPrice) {
		            v.price = minPrice; // 价格一致时，直接赋值单个价格
		        } else {
		            v.price = `${minPrice}-${maxPrice}`; // 价格不一致时，保留区间格式
		        }
		    }
		    console.log(v.masterImg)
		})
		this.originList = this.list
	},
	//关闭弹框
	handleClose(){
		this.$emit('close')
	},
	//显示商品详情
	handleDetail(index){
		this.data = this.list[index]
		this.isDetail = true
	},
	//选择数量
	handleNum(data){
		if(this.num == 1 && data == -1){
			return
		}
		this.num = this.num + data
	},
	//选择规格
	handleGg(index){
		this.ggIndex = index
	},
	//立即加购
	async submitOrder(){
		const params = {
			num:this.num,
			dbSpecificationId:this.data.specificationList[this.ggIndex].dbSpecificationId
		}
		const res = await submitOrder(params)
		this.$message({ message: res.msg,type: 'success'});
	},
	handleImgError(e) {
	    // e.target 指向加载失败的 img 元素，替换其 src 为默认图片
	    e.target.src = this.defaultGoodsImg;
	    // 可选：防止默认图片也加载失败时无限触发 onerror 事件
	    e.target.onerror = null;
	},

  }
};
</script>
<style scoped lang="scss">
	@import "./gouwuche.css";
</style>


// WEBPACK FOOTER //
// gouwuche.vue?46b48ce4